import { Role } from '#shared/model'

export default function getBaseRoutePathByRole(role: Role) {
  if (role === 'manager') {
    return '/support' as const
  }

  return `/${role}` as const
}
